import { TFnType } from '@tolgee/react'

import {
  GET_STORE_SIMPLE,
  GET_TENANT_STORES_SIMPLE,
  GetStoreSimpleQuery,
  GetStoreSimpleQueryVariables,
  GetTenantStoresQueryVariables,
  GetTenantStoresSimpleQuery,
  Ordering,
} from '@/graphql'
import { Filter, FilterOptions } from '@/pages/components/FilterBar'

export const STORE_IDS_KEY_URL = 'storeIds'
export const BRAND_IDS_KEY_URL = 'brandIds'

const StoreFilter = (
  t: TFnType,
): Filter & { options: FilterOptions['search'] } => {
  return {
    label: t('common.stores'),
    type: 'search',
    options: {
      multiselect: true,
      urlKey: STORE_IDS_KEY_URL,
      query: GET_TENANT_STORES_SIMPLE,
      getOptions: (data?: GetTenantStoresSimpleQuery) =>
        data?.tenantStores.results.map((s: any) => ({
          label: s.location.name,
          value: s.id,
        })) || [],
      getVariablesForQuery: (
        textInput: string,
      ): GetTenantStoresQueryVariables => ({
        filters: {
          location_Name: { iContains: textInput },
          onlyMyStores: true,
          isActive: true,
        },
        order: { name: Ordering.ASC },
      }),
      getOneQuery: GET_STORE_SIMPLE,
      getOneVariables: (id: string): GetStoreSimpleQueryVariables => ({
        id,
      }),
      getOneMap: (data?: GetStoreSimpleQuery) =>
        data && data.store.location
          ? {
              [data.store.id]: data.store.location.name,
            }
          : null,
    },
  }
}

export const CommonFilters = {
  StoreFilter: (t: TFnType) => StoreFilter(t),
}
